<template lang="pug">
#lista-operacao
    BaseHeader(
        :titulo="$t('mensagens.operacao.titulo')",
        icon='el-icon-circle-plus-outline',
        iconBotaoSecundario='el-icon-upload',
        :btnTexto="$t('mensagens.operacao.botaoCadastro')",
        :btnTextoAcoes="$t('mensagens.operacao.botaoAcoesLote')",
        :exibeBotao='true',
        :exibeBotaoSecundarioAcao='exibeBotaoSecundarioAcao()',
        :acoes='acoes',
        @realizarAcao='realizarAcao($event)',
        @btnHeaderClicado='novaOperacao'
    )

    .view-container-base-header
        section.lista-operacao__barra-pesquisa
            i.el-icon-search
            input.lista-operacao__barra-pesquisa__input(
                v-model='filtro',
                type='text',
                :placeholder="$t('mensagens.operacao.pesquisaInteligente')",
                autocomplete='off',
                @keyup.enter='buscarOperacoes(0)'
            )

        section.lista-operacao__filtros
            .botao_upload
                span.lista-operacao__filtros__titulo {{ $t('mensagens.operacao.selecaoVisualizar') }}

            el-skeleton.d-flex(
                :rows='1',
                :loading='buscandoFiltrosStatus',
                animated,
                style='justify-content: space-between'
            )
                template(slot='template')
                    el-skeleton-item
                template
                    .d-flex
                        .lista-operacao__filtros__item(
                            v-for='(filtroStatus, index) in status',
                            :key='index',
                            @click='buscarOperacoesPorStatus(filtroStatus)',
                            :class='filtroStatus.ativo ? "filtro-ativo" : "filtro-inativo"'
                        ) {{ $t(`mensagens.operacao.${filtroStatus.codigo}`) }}

                    el-checkbox(
                        style='display: flex; align-items: center',
                        v-model='filtrarOperacoesComAlertas',
                        @change='buscarOperacoes(0)'
                    ) {{ $t('mensagens.operacao.mostrarComAlerta') }}

        section.lista-operacao__tabela
            el-table(
                :data='operacoes',
                stripe,
                height='calc(100% - 48px)',
                @sort-change='ordenar',
                v-loading='carregandoTabela',
                :empty-text="$t('mensagens.operacao.tabela.vazia')"
            )
                el-table-column(type='expand')
                    template(slot-scope='props')
                        .box-expande-listagem
                            .box-expande-listagem-box
                                .box-expande-listagem-box-texto
                                    | {{ $t('mensagens.operacao.atividades') }}
                                .box-expande-listagem-box-value
                                    div(
                                        v-for='atividade in props.row.atividades',
                                        :key='atividade.id'
                                    )
                                        | {{ atividade.produto }} - {{ atividade.tipo }}

                            .box-expande-listagem-box
                                .box-expande-listagem-box-texto
                                    | {{ $t('mensagens.operacao.pessoasVinculadas') }}
                                .box-expande-listagem-box-value
                                    div(
                                        v-for='pessoa in props.row.pessoasVinculadas',
                                        :key='pessoa.id'
                                    )
                                        | {{ pessoa.nome }} - {{ pessoa.papel }}

                            .box-expande-listagem-box
                                .box-expande-listagem-box-texto
                                    | {{ $t('mensagens.operacao.carOperacao') }}
                                .box-expande-listagem-box-value(
                                    v-if='props.row.territorios !== null && props.row.territorios.length > 0'
                                )
                                    div(
                                        v-for='(territorio, index) in props.row.territorios',
                                        :key='territorio.id'
                                    )
                                        .pb-2(v-if='index === 0') {{ territorio.nome }}
                                        .py-2(v-else) {{ territorio.nome }}
                                        div(
                                            v-for='(car, index) in territorio.cars',
                                            :key='index'
                                        )
                                            div {{ car }}
                                .pl-1(v-else) --

                el-table-column(:label="$t('mensagens.operacao.tabela.id')")
                    template(slot-scope='scope')
                        p(style='word-break: break-all')
                            span(style='word-break: break-all') {{ scope.row.identificador ? scope.row.identificador : '--' }}
                            span.alerta(
                                v-if='scope.row.possuiAlertas && scope.row.status !== "Cancelado" ',
                                style='word-break: normal'
                            )
                                | {{ $t('mensagens.operacao.tabela.alerta') }}

                el-table-column(:label="$t('mensagens.operacao.tabela.nome')", sortable)
                    template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(
                    :label="$t('mensagens.operacao.tabela.dataLiberacao')",
                    align='center',
                    sortable
                )
                    template(slot-scope='scope')
                        span {{ scope.row.dataLiberacao }}

                el-table-column(:label="$t('mensagens.operacao.tabela.vigencia')", align='center', sortable)
                    template(slot-scope='scope')
                        span {{ scope.row.vigencia }}

                el-table-column(:label="$t('mensagens.operacao.tabela.numContrato')", align='center')
                    template(slot-scope='scope')
                        span {{ scope.row.numeroContrato ? scope.row.numeroContrato : '--' }}

                el-table-column(:label="$t('mensagens.operacao.tabela.categoria')", align='center')
                    template(slot-scope='scope')
                        span {{ scope.row.categoria ? scope.row.categoria : '--' }}

                el-table-column(:label="$t('mensagens.comuns.situacao')", align='center')
                    template(slot-scope='scope')
                        span(:class='["tag", tratarStatus(scope.row.status)]') {{ scope.row.status ? $t(`mensagens.operacao.${scope.row.statusCodigo}`) : '--' }}

                el-table-column(:label="$t('mensagens.operacao.tabela.acoes')", width='100', align='center')
                    template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical.mudando-cursor
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    v-for='(acoes, index) in scope.row.acoesDisponiveis',
                                    :key='index',
                                    :icon='operacaoStatusAcoes[acoes].icone',
                                    @click.native='operacaoStatusAcoes[acoes].callback(scope.row)'
                                ) {{ $t(`mensagens.operacao.acoes.${operacaoStatusAcoes[acoes].codigo}`) }}

            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ paginacao.total }} {{ $t('mensagens.operacao.tabela.rodapePaginacao') }}

                .tabela-rodape--pagination
                    el-pagination(
                        small,
                        layout='prev, pager, next',
                        :page-size='paginacao.itensPorPagina',
                        :current-page.sync='paginacao.pagina',
                        :total='paginacao.total',
                        @current-change='buscarOperacoes(paginacao.pagina - 1)'
                    )

    ModalCancelamentoOperacao(
        :operacao='operacao',
        :show.sync='mostrarModalCancelamento',
        @cancelarOperacao='buscarOperacoes(0)'
    )

    ModalConfirmarInicioAnaliseOperacao(
        :operacao='operacao',
        :show.sync='mostrarModalConfirmarAnalise',
        @iniciarAnalise='analisarOperacao'
    )

    ModalUploadAlteracaoOperacaoLote(
        :show.sync='showModalAlteracaoOperacaoLote',
        @atualizar='buscarOperacoes(0)'
    )

    ModalUploadCancelamentoOperacaoLote(
        :show.sync='showModalCancelamentoOperacaoLote',
        @atualizar='buscarOperacoes(0)'
    )

    ModalUploadInibicaoEmLote(
        :show.sync='showModalInibicaoEmLote',
        @atualizar='buscarOperacoes(0)'
    )

    ModalUploadCadastroOperacaoEmLote(
        :show.sync='showModalCadastroOperacaoEmLote',
        @atualizar='buscarOperacoes(0)'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalCancelamentoOperacao from '@/components/operacao/gestao/ModalCancelamentoOperacao.vue';
import ModalConfirmarInicioAnaliseOperacao from '@/components/operacao/gestao/ModalConfirmarInicioAnaliseOperacao.vue';
import ModalUploadAlteracaoOperacaoLote from '@/components/operacao/gestao/ModalUploadAlteracaoEmLote.vue';
import ModalUploadCancelamentoOperacaoLote from '@/components/operacao/gestao/ModalUploadCancelamentoEmLote.vue';
import ModalUploadInibicaoEmLote from '@/components/operacao/gestao/ModalUploadInibicaoEmLote.vue';
import ModalUploadCadastroOperacaoEmLote from '@/components/operacao/gestao/ModalUploadCadastroOperacaoEmLote.vue';
import OperacaoService from '@/services/OperacaoService';
import OperacaoLaudoService from '@/services/OperacaoLaudoService';
import { mapState } from 'vuex';

export default {
    name: 'index',
    components: {
        BaseHeader,
        ModalConfirmarInicioAnaliseOperacao,
        ModalCancelamentoOperacao,
        ModalUploadAlteracaoOperacaoLote,
        ModalUploadCancelamentoOperacaoLote,
        ModalUploadInibicaoEmLote,
        ModalUploadCadastroOperacaoEmLote
    },
    data() {
        return {
            buscandoFiltrosStatus: false,
            filtro: this.$store.state.operacao.filtro,
            filtrosStatus: this.$store.state.operacao.filtrosStatus,
            filtrarOperacoesComAlertas:
                this.$store.state.operacao.filtrarOperacoesComAlertas,
            status: [],
            acoes: [
                {
                    titulo: this.$t('mensagens.operacao.acoes.CADASTRAR_LOTE'),
                    codigo: 'CADASTRAR_LOTE',
                    emit: 'cadastrarLote'
                },
                {
                    titulo: this.$t('mensagens.operacao.acoes.ALTERAR_LOTE'),
                    codigo: 'ALTERAR_LOTE',
                    emit: 'alteracao' },
                {
                    titulo: this.$t('mensagens.operacao.acoes.CANCELAR_LOTE'),
                    codigo: 'CANCELAR_LOTE',
                    emit: 'cancelamento'
                },
                {
                    titulo: this.$t('mensagens.operacao.acoes.INIBIR_LOTE'),
                    codigo: 'INIBIR_LOTE',
                    emit: 'inibir'
                }
            ],
            mostrarModalCancelamento: false,
            mostrarModalConfirmarAnalise: false,
            showModalAlteracaoOperacaoLote: false,
            showModalCancelamentoOperacaoLote: false,
            showModalInibicaoEmLote: false,
            showModalCadastroOperacaoEmLote: false,
            carregandoTabela: false,
            operacao: {},
            operacoes: [],
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            operacaoStatusAcoes: {
                ANALISAR: {
                    nome: this.$t('mensagens.operacao.acoes.analisar'),
                    codigo: 'INICIAR_ANALISE',
                    icone: 'el-icon-finished',
                    callback: this.confirmarIniciarAnaliseOperacao
                },
                CANCELAR: {
                    nome: this.$t('mensagens.operacao.acoes.cancelar'),
                    codigo: 'CANCELAR',
                    icone: 'el-icon-circle-close',
                    callback: this.cancelarOperacao
                },
                CLONAR: {
                    nome: this.$t('mensagens.operacao.acoes.clonar'),
                    codigo: 'CLONAR',
                    icone: 'el-icon-document-copy',
                    callback: this.clonarOperacao
                },
                CONTINUAR_ANALISE: {
                    nome: this.$t('mensagens.operacao.acoes.continuarAnalise'),
                    codigo: 'CONTINUAR_ANALISE',
                    icone: 'el-icon-finished',
                    callback: this.analisarOperacao
                },
                EDITAR: {
                    nome: this.$t('mensagens.operacao.acoes.editar'),
                    codigo: 'EDITAR',
                    icone: 'el-icon-edit',
                    callback: this.editarOperacao
                },
                EXPORTAR_ANALISE: {
                    nome: this.$t('mensagens.operacao.acoes.exportaAnalise'),
                    codigo: 'EXPORTAR_ANALISE',
                    icone: 'el-icon-picture-outline',
                    callback: this.exportarAnaliseSocioambiental
                },
                GERAR_ARQUIVO_XLSX: {
                    nome: this.$t('mensagens.operacao.acoes.xlsx'),
                    codigo: 'GERAR_ARQUIVO_XLSX',
                    icone: 'el-icon-download',
                    callback: this.gerarArquivoCoordenadasXLSX
                },
                GERAR_ARQUIVO_BNDES_XLSX: {
                    nome: this.$t('mensagens.operacao.acoes.xlsxBNDES'),
                    codigo: 'GERAR_ARQUIVO_BNDES_XLSX',
                    icone: 'el-icon-download',
                    callback: this.gerarArquivoCoordenadasXLSXBndes
                },
                SOLICITAR_FISCALIZACAO: {
                    nome: this.$t('mensagens.operacao.acoes.fiscalizar'),
                    codigo: 'SOLICITAR_FISCALIZACAO',
                    icone: 'el-icon-zoom-in',
                    callback: this.solicitarFiscalizacao
                },
                VISUALIZAR: {
                    nome: this.$t('mensagens.operacao.acoes.visualizar'),
                    codigo: 'VISUALIZAR',
                    icone: 'el-icon-view',
                    callback: this.visualizarOperacao
                },
                VISUALIZAR_MONITORAMENTO: {
                    nome: this.$t('mensagens.operacao.acoes.monitoramento'),
                    codigo: 'VISUALIZAR_MONITORAMENTO',
                    icone: 'el-icon-monitor',
                    callback: this.visualizarMonitoramento
                }
            }
        };
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    async mounted() {
        await this.buscarOperacoes(0);
        await this.buscarStatusFiltro();
    },

    methods: {
        exibeBotaoSecundarioAcao() {
            return this.usuarioLogado.isAdmin;
        },
        analisarOperacao(operacao = null) {
            if (operacao) this.operacao = operacao;
            this.$router.push({
                name: 'operacaoAnalisar',
                params: { id: this.operacao.id }
            });
        },

        abrirModalUploadLote() {
            this.showModalAlteracaoOperacaoLote = true;
        },

        abrirModalCancelamentoLote() {
            this.showModalCancelamentoOperacaoLote = true;
        },

        abrirModalInibicaoEmLote() {
            this.showModalInibicaoEmLote = true;
        },
        abrirModalCadastroLote() {
            this.showModalCadastroOperacaoEmLote = true;
        },

        async solicitarFiscalizacao(operacao) {
            await OperacaoLaudoService.inserir({ idOperacao: operacao.id })
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.fiscalizacaoSucedida')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erro')
                    });
                });
        },

        realizarAcao(acao) {
            switch (acao) {
                case 'alteracao':
                    return this.abrirModalUploadLote();
                case 'cancelamento':
                    return this.abrirModalCancelamentoLote();
                case 'inibir':
                    return this.abrirModalInibicaoEmLote();
                case 'cadastrarLote':
                    return this.abrirModalCadastroLote();
            }
        },

        async buscarOperacoes(pagina) {
            this.carregandoTabela = true;
            this.paginacao.pagina = pagina;
            this.$store.commit('SET_FILTROS_OPERACAO', {
                filtro: this.filtro,
                filtrosStatus: this.filtrosStatus,
                filtrarOperacoesComAlertas: this.filtrarOperacoesComAlertas
            });

            await OperacaoService.buscar(
                this.filtro,
                this.filtrosStatus,
                this.paginacao,
                this.filtrarOperacoesComAlertas
            ).then(({ data }) => {
                this.operacoes = data.itens;

                this.paginacao.pagina = data.paginacao.pagina + 1;
                this.paginacao.total = data.paginacao.total;
                this.paginacao.itensPorPagina = data.paginacao.itensPorPagina;
                this.paginacao.totalPaginas = data.paginacao.totalPaginas;
            });
            this.carregandoTabela = false;
        },

        async buscarStatusFiltro() {
            this.buscandoFiltrosStatus = true;
            await OperacaoService.buscarStatusFiltro()
                .then(({ data }) => {
                    this.status = data.status;
                    this.status.forEach(status => (status.ativo = false));
                    if (this.filtrosStatus && this.filtrosStatus.length > 0) {
                        this.filtrosStatus.forEach(item => {
                            this.status
                                .filter(status => status.codigo === item)
                                .map(statusFiltrado => {
                                    statusFiltrado.ativo = true;
                                });
                        });
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroSituacao')
                    });
                })
                .finally(() => (this.buscandoFiltrosStatus = false));
        },

        buscarOperacoesPorStatus(filtroStatus) {
            if (filtroStatus.ativo) {
                filtroStatus.ativo = false;
                this.filtrosStatus = this.filtrosStatus.filter(
                    item => item !== filtroStatus.codigo
                );
            } else {
                filtroStatus.ativo = true;
                this.filtrosStatus.push(filtroStatus.codigo);
            }

            this.buscarOperacoes(0);
        },

        cancelarOperacao(operacao) {
            this.operacao = operacao;
            this.mostrarModalCancelamento = true;
        },

        clonarOperacao(operacao) {
            this.$router.push({
                name: 'operacaoClonar',
                params: { id: operacao.id, acao: 'clonar' }
            });
        },

        confirmarIniciarAnaliseOperacao(operacao) {
            this.operacao = operacao;
            this.mostrarModalConfirmarAnalise = true;
        },

        editarOperacao(operacao) {
            this.$router.push({
                name: 'operacaoEditar',
                params: { id: operacao.id, acao: 'editar' }
            });
        },

        async exportarAnaliseSocioambiental(operacao) {
            try {
                await OperacaoService.exportarAnalise(operacao.id);

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.analiseExportada')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.analiseErro')
                });
            }
        },

        ordenar(props) {
            this.paginacao.direcao = props.order;
            this.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.paginacao.ordernarPor = null;
            this.buscarOperacoes(0);
        },

        async gerarArquivoCoordenadasXLSX(operacao) {
            try {
                await OperacaoService.baixarCoordenadasExcel(operacao.id);

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.downloadErro')
                });
            }
        },

        async gerarArquivoCoordenadasXLSXBndes(operacao) {
            try {
                await OperacaoService.baixarCoordenadasExcelBndes(operacao.id);

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.downloadErro')
                });
            }
        },

        novaOperacao() {
            this.$router.push({ name: 'operacaoCadastrar' });
        },

        visualizarOperacao(operacao) {
            this.$router.push({
                name: 'operacaoVisualizar',
                params: { id: operacao.id, operacao }
            });
        },

        visualizarMonitoramento(operacao) {
            this.$router.push({
                name: 'operacaoMonitoramento',
                params: { id: operacao.id, operacao }
            });
        },

        tratarStatus(status) {
            if (status === 'Aprovado' || status === 'Reprovado' || status === 'Cancelado') {
                return status.toLowerCase();
            } else if (status === 'Aguardando aprovação') {
                return 'aguardando-aprovacao';
            } else if (status === 'Em análise') {
                return 'em-analise';
            } else if (status === 'Processando os monitoramentos da operação') {
                return 'em-processamento';
            } else if (status === 'Vencido') {
                return 'vencido';
            }
            return '';
        }
    }
};
</script>

<style lang="scss">
#lista-operacao {
    height: 100%;
    width: 100%;

    .lista-operacao__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-operacao__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .lista-operacao__filtros {
        height: 64px;
        margin-bottom: 34px;

        .lista-operacao__filtros__titulo {
            font-size: map-get($font-size, big);
            color: var(--primary-font-color);
        }

        .lista-operacao__filtros__item {
            transition: all 0.3s ease-in-out;
            font-weight: map-get($font-weight, normal);
            font-size: map-get($font-size, small);
            align-items: center;
            display: flex;
            padding: 0 20px;
            height: 35px;
            cursor: pointer;
            border-radius: 30px;
            margin-right: 15px;
            margin-top: 5px;
            box-shadow: 0 1px 5px 0 var(--block-shadow);
        }

        .filtro-ativo {
            background-color: var(--primary);
            color: var(--white);
        }

        .filtro-inativo {
            background-color: var(--white);
            color: var(--primary);
        }
    }

    .lista-operacao__tabela {
        border-radius: 5px;
        height: calc(100vh - 370px);
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            font-weight: bold;
            font-size: 14px;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            margin-top: 8px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }
    }

    .alerta {
        margin-left: 7px;
        font-weight: 500;
        border-radius: 5px;
        width: auto;
        padding: 3px;
        font-size: 11px;
        border: 1px solid var(--tag-danger-border);
        background-color: var(--tag-danger-background);
        color: var(--tag-danger-text);
    }

    .el-skeleton__text {
        height: 35px;
        width: 35%;
    }

    .el-tag {
        border-radius: 20px !important;
        border: none !important;
        text-align: center;
    }

    .mudando-cursor {
        cursor: pointer;
    }

    .tag {
        border-radius: 5px;
        text-align: center;
        font-size: 11px;
        font-weight: 500;
        padding: 3px;
    }

    .aprovado {
        border: 1px solid var(--tag-success-border);
        background-color: var(--tag-success-background);
        color: var(--tag-success-text);
    }

    .reprovado {
        border: 1px solid var(--tag-danger-border);
        background-color: var(--tag-danger-background);
        color: var(--tag-danger-text);
    }

    .cancelado {
        border: 1px solid var(--tag-danger-border);
        background-color: var(--tag-danger-background);
        color: var(--tag-danger-text);
    }

    .em-analise {
        border: 1px solid var(--tag-warning-border);
        background-color: var(--tag-warning-background);
        color: var(--tag-warning-text);
    }

    .em-processamento {
        border: 1px solid var(--dark);
        background-color: var(--light);
        color: var(--dark);
    }

    .vencido {
        border: 1px solid var(--tag-danger-border);
        background-color: var(--tag-danger-background);
        color: var(--tag-danger-text);
    }

    .aguardando-aprovacao {
        border: 1px solid var(--tag-gray-border);
        background-color: var(--tag-gray-background);
        color: var(--tag-gray-text);
    }
    .botao_upload {
        display: flex;
        justify-content: space-between;
    }
}
</style>
